export const en_us = {
    'Error trying to get the approval settings': 'Error trying to get the approval settings: ',
    Loading: 'Loading...',
    Type: 'Type',
    'Schedule Type': 'Schedule Type',
    'Alert Rule': 'Alert Rule',
    'Check alert rule': 'Check alert rule',
    The: 'The ',
    Asset: 'Asset',
    Timespan: 'Timespan',
    Frequency: 'Frequency',
    Hour: 'Hour',
    'alert rule must start with the event type': ' alert rule must start with the event type: ',
    'The pipes expression must contain the necessary fields for the selected report, as shown below':
        'The pipes expression must contain the necessary fields for the selected report, as shown below:',
    'Report Content Source': 'Report Content Source',
    Select: 'Select...',
    'Report Approval Settings': 'Report Approval Settings',
    'Timespan delimits successive start and end dates, linked to the configured recurrence.':
        'Timespan delimits successive start and end dates, linked to the configured recurrence.',
    Recurrence: 'Recurrence',
    'Server local time': 'Server local time: '
}
